import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    const token = await cookies.get('@P100:token');

    if (token) {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      Object.assign(config.headers, headers);
    }

    return config;
  },
);

api.interceptors.response.use(
  (config: AxiosResponse): AxiosResponse => config,
  (error: AxiosError): void => {
    const path = window.location.href.split('/');
    const href = path[path.length - 1];

    if (error.response?.status === 401 && href !== '') {
      cookies.remove('@P100:token');
      cookies.remove('@P100:user');
      window.location.reload();
    } else {
      throw new Error(JSON.stringify(error.response?.data));
    }
  },
);

export default api;
